import React from "react";
import { Navigate } from "react-router-dom";
import { useCase } from "src/context/case-context";

export function RequireCustomerData({ children }: { children: React.ReactNode }) {
  const { customerData } = useCase();

  if (!customerData) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
